import React from 'react';
import { CaseStudyShell } from '../components/case-study/CaseStudyShell';
import { CaseHeader } from '../components/case-study/CaseHeader';
import { CaseSection } from '../components/case-study/CaseSection';
import { Figure } from '../components/case-study/Figure';
import { NextCase } from '../components/case-study/NextCase';
import { Reveal } from '../components/Reveal';
import { PalacioHeroMock } from '../components/palacio/PalacioHeroMock';
import { palacioDecisions, palacioMeta, palacioStats, palacioWorkingStyle } from '../data/palacio';
export function PalacioCaseStudy() {
  return <CaseStudyShell data-id="element-815" data-mp="2islpd7m6a58p">
      <CaseHeader overline="Case study · Luxury retail & fintech" title="Palacio de Hierro: luxury shopping and credit in one app" intro="Palacio de Hierro, a Mexican luxury department store, had a retail site on one side and a credit card that only lived in-store on the other. I led the credit workstream that brought both into a single app, shipped in 11 months." meta={palacioMeta} data-id="element-816" data-mp="2itww9gawzt41" />

      <Figure className="mt-14" data-id="element-817" data-mp="3tw1fn50osyae">
        <PalacioHeroMock data-id="element-818" data-mp="2if03yyurx18" />
      </Figure>

      <Reveal className="mt-6" data-id="element-819" data-mp="2jgmgzlbk5y9">
        <dl className="grid grid-cols-2 gap-y-6 rounded-2xl bg-surface p-5 md:grid-cols-4 md:divide-x md:divide-line md:p-6" data-id="element-820" data-mp="2khz38hzh0i3">
          {palacioStats.map(stat => <div key={stat.label} className="md:px-5 md:first:pl-0" data-id="element-821" data-mp="3oysyn7r9z0aq">
              <dt className="sr-only" data-id="element-822" data-mp="gi6j6e4883m3">{stat.label}</dt>
              <dd data-id="element-823" data-mp="ggdeh4d6btgq">
                <span className="block text-2xl font-semibold tracking-tight text-ink md:text-[28px]" data-id="element-824" data-mp="lhj8d5iklmru">{stat.value}</span>
                <span className="mt-1 block text-xs text-fg-muted" data-id="element-825" data-mp="7ijglozrgrrg">{stat.label}</span>
              </dd>
            </div>)}
        </dl>
      </Reveal>

      <CaseSection index="01" label="The problem" title="Two products, one customer, no shared home" intro={<>
            <p data-id="element-827" data-mp="2wadmqu3fwy3m">
              Shoppers browsed on a mobile retail site, but anything to do with their Palacio credit card meant going to a
              store. There was no budget or time for two separate apps, so retail and credit had to live together, with a
              super app as the reference model.
            </p>
            <p data-id="element-828" data-mp="sz8v8qetue6o">
              The harder problem was people. Around 40 stakeholders, and marketing and credit both wanted the same home
              screen.
            </p>
          </>} data-id="element-826" data-mp="bl7qm007o4q0" />

      <CaseSection index="02" label="How I worked" title="Alignment first, pixels second" data-id="element-829" data-mp="jyarm98aw8om">
        <div className="grid gap-3 md:grid-cols-3" data-id="element-830" data-mp="ezzjq41kg891">
          {palacioWorkingStyle.map((item, i) => <Reveal key={item.title} delay={i * 0.05} className="h-full" data-id="element-831" data-mp="a4af3maow15v" data-mpi={i}>
              <div className="h-full rounded-2xl border border-line bg-white p-5" data-id="element-832" data-mp="54ekgdnvtm2z">
                <h3 className="text-sm font-semibold text-fg" data-id="element-833" data-mp="24f5yzkrbr2ny">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-fg-muted" data-id="element-834" data-mp="1zgmc9i4wpmuj">{item.body}</p>
              </div>
            </Reveal>)}
        </div>
      </CaseSection>

      <CaseSection index="03" label="Key decisions" title="Three calls that shaped the app" data-id="element-835" data-mp="27wbtsghv7gni">
        <ol className="space-y-3" data-id="element-836" data-mp="2bxdkua1momee">
          {palacioDecisions.map((decision, i) => <Reveal key={decision.letter} delay={i * 0.05} data-id="element-837" data-mp="2gsjha2snpjgq" data-mpi={i}>
              <li className="grid grid-cols-[32px_1fr] gap-4 rounded-2xl bg-surface p-5 md:grid-cols-[56px_1fr] md:p-6" data-id="element-838" data-mp="2lohyn6fki17n">
                <span className="text-xl font-semibold text-rust" data-id="element-839" data-mp="1p0v97sgwvj3p">{decision.letter}</span>
                <div data-id="element-840" data-mp="1t1ni2klvflzg">
                  <h3 className="text-[15px] font-semibold text-fg" data-id="element-841" data-mp="1t2ykoh3kynoz">{decision.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-fg-muted" data-id="element-842" data-mp="1xynnquet6mq1">{decision.body}</p>
                </div>
              </li>
            </Reveal>)}
        </ol>
      </CaseSection>

      <CaseSection index="04" label="Reflection" title="What I'd do differently" intro={<p data-id="element-844" data-mp="3eg1p9behuhjo">
            I'd bring engineering into the co-creation workshops from the start. The white-label pivot came late because
            we learned the build constraints after the flows were set; knowing them sooner would have saved a round of
            rework.
          </p>} data-id="element-843" data-mp="39evtt5tg8g6g" />

      <NextCase title="Clear Docs Mobile: deciding what loan officers don't need on a phone" href="/work/clear-docs" data-id="element-845" data-mp="v7crbf7muqe1" />
    </CaseStudyShell>;
}